<template>
  <div class="anketa-2cols styles">
    <div v-html="title" class="title"></div>
    <div class="bottom">
      <VueScrollPicker
          v-if="options"
          :options="options"
          v-model="modelValue"
          empty="Error"
          placeholder="-"
      />
    </div>
    <primary-button
        @click="finished();"
        :disabled="disabled"
        :text="button.text"
        />
  </div>

</template>

<script>
import StyleBlock from "@/components/Anketa/StyleBlock";
import {useHeaderStore} from '@/stores/header'
import anketaMixin from "@/mixins/anketaMixin";
import {useAnketaStore} from "@/stores/anketa";
import {ref} from "vue";
import bottomData from "@/data/anketa/bottomData";
import headerMixin from "@/mixins/headerMixin";
import selectedMixin from "@/mixins/selectedMixin";
import {useSettingsStore} from "@/stores/settings";
import appMixin from "@/mixins/appMixin";
import {mapState} from "pinia";
import {useUserStore} from "@/stores/users";
import router from "@/router";
import {useApiStore} from "@/stores/api";
import {emitAnketaFinishedCallback} from "@/helpers/anketaFinishedCallback";

export default {
  name: 'TopQuestionView',
  components: {StyleBlock},
  mixins: [anketaMixin,headerMixin, selectedMixin, appMixin],
  props: ['header'],
  setup() {
    const anketaStore = useAnketaStore();
    const { setValue,getStepData,steps,postAnketa } = anketaStore;
    let modelValue = ref(getStepData(steps.step9))
    const {setHeaderData} = useHeaderStore();
    const settings = useSettingsStore();
    const api = useApiStore();

    return {
      setHeaderData, setValue,getStepData,steps,
      modelValue, settings, postAnketa,api, anketaStore
    };
  },
  watch:{
    modelValue(newVal){
      this.select(newVal)
      this.disabled = newVal == null;
    }
  },
  created() {
    this.datas = this.settings.getSetting(this.stepId)
    Object.keys(this.datas).forEach(key => {
      this.options.push({
        value: this.datas[key].value,
        name: this.datas[key].name.text,
      });
    });
  },
  mounted() {
    if (this.modelValue == null) {
      this.disabled = true
    }
  },
  computed: {
    ...mapState(useUserStore, ['user','subscribed']),
  },
  methods:{
    async finished(){
      const isReedit = this.anketaStore.isFinished();
      const fromPage = this.anketaStore.formFromPage ?? null;
      await this.api.onStageEvent('onFormStage', 'finish', isReedit ? false : null, fromPage);
      this.setValue('finished', true);
      this.anketaStore.clearFormFromPage();

      try {
        await this.postAnketa();
      } catch (error) {
        console.error('Ошибка сохранения анкеты:', error);
        return;
      }

      const preview = await this.api.getPreview();
      if (preview && preview.time_to_open) {
        const parts = preview.time_to_open.split(':');
        const timer = parseInt(parts[0], 10) * 3600 + parseInt(parts[1], 10) * 60 + parseInt(parts[2], 10);
        this.setValue('countDown', timer || null);
      }

      emitAnketaFinishedCallback(this.appEvent, {
        user: this.user,
        subscribed: this.subscribed,
        preview,
        isReedit,
      });

      return router.push(`/?clientHash=${this.user.hash}&clientName=${this.user.name}&subscribed=${this.subscribed}`);
    }
  },
  data() {
    return {
      stepId: 'bottom_size',
      title: "<span>Выбери, какой у тебя размер низа:</span>",
      button: {
        text: 'Завершить',
        link: 'home',
      },
      step_number: "step9",
      options: [],
    }
  }
}
</script>
<style scoped>


</style>
